// eslint-disable-next-line import/namespace
import * as d3 from 'd3'
import { Tree } from './data'
import { useRouter } from 'next/router'
import BaseEmpty from '@/components/BaseEmpty'
import { useWindowWidth } from '@/hooks/useWindowWidth'
import { FC, useMemo, useRef, useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { Flex } from '@mantine/core'
import { CoinChartsStyled } from '@/blocks/Price/PriceChart/style'
import { TreeChartBoxStyled } from './style'
import TreeChartItem from '@/blocks/Price/PriceChart/HeatChart/Item'
import { useAdapter } from '@/components/Adapter'

type HeatChartProps = {
  data: any[]
}

const HeatChart: FC<HeatChartProps> = ({ data }) => {
  const { isH5 } = useAdapter()
  const { locale } = useRouter()
  const treeData = useMemo((): Tree => {
    return {
      type: 'node',
      name: '',
      value: 0,
      children: data.sort((a, b) => b['percentage'] - a['percentage']),
    }
  }, [data])

  const heatChartRef = useRef<HTMLDivElement>(null) // 用于绑定 DOM 容器
  const windowWidth = useWindowWidth()

  const [treeBoxWidth, setTreeBoxWidth] = useState<number>(0)
  const height = useMemo(() => {
    if (isH5) {
      return 293
    }
    return 418
  }, [isH5])

  useEffect(() => {
    const ele = document.getElementById('price-width-id')
    const element = ele?.getBoundingClientRect()

    setTreeBoxWidth((element?.width ?? 0) + 8)
  }, [windowWidth])

  const hierarchy = useMemo(() => {
    // eslint-disable-next-line import/namespace
    return d3.hierarchy(treeData).sum((d: any) => Math.abs(d['change']))
  }, [treeData])

  const root = useMemo(() => {
    // eslint-disable-next-line import/namespace
    const treeGenerator = d3.treemap<Tree>().size([treeBoxWidth, height]).padding(4)

    return treeGenerator(hierarchy)
  }, [hierarchy, treeBoxWidth, height])

  return (
    <CoinChartsStyled ref={heatChartRef} style={{ overflow: 'hidden' }}>
      {data?.length ? (
        <TreeChartBoxStyled
          key={'key' + treeBoxWidth}
          width={treeBoxWidth}
          height={height}
          data-ar={String(locale === 'ar')}
        >
          {root.leaves().map((leaf: any) => {
            return <TreeChartItem key={leaf.id} leaf={leaf} />
          })}
        </TreeChartBoxStyled>
      ) : (
        <Flex h={height} align="center">
          <BaseEmpty size="md" />
        </Flex>
      )}
    </CoinChartsStyled>
  )
}

export default observer(HeatChart)
